import { TaskFilters, TaskSortDirection, TaskSortField, TaskType } from "@myapp/contract";
import { toOptionalString } from "../../../../shared/lib/optionalParsers";
import { StatusFilterValue } from "../../../../entities/task";

export interface AufgabenFiltersForm {
  technicianName: string;
  taskType: TaskType | null;
  status: StatusFilterValue | null;
  title: string;
  plannedStart: string;
  deadline: string;
  sortField: TaskSortField;
  sortDirection: TaskSortDirection;
}

export const INITIAL_AUFGABEN_FILTERS: AufgabenFiltersForm = {
  technicianName: "",
  taskType: null,
  status: null,
  title: "",
  plannedStart: "",
  deadline: "",
  sortField: "plannedStart",
  sortDirection: "DESC",
};

export const mapFiltersFormToApi = (
  filters: AufgabenFiltersForm,
  limit: number,
): TaskFilters => ({
  limit,
  technicianName: toOptionalString(filters.technicianName),
  taskType: filters.taskType ?? undefined,
  status: filters.status === "NEEDS_RESCHEDULING" ? undefined : (filters.status ?? undefined),
  needsRescheduling: filters.status === "NEEDS_RESCHEDULING" ? true : undefined,
  title: toOptionalString(filters.title),
  plannedStartFrom: toOptionalString(filters.plannedStart),
  deadlineFrom: toOptionalString(filters.deadline),
  sortField: filters.sortField,
  sortDirection: filters.sortDirection,
});
